import { RALLI } from '../data/ralli';

// Height tokens per size.
const IMG_SIZES = {
  xs: 'h-6 md:h-6',
  sm: 'h-8 md:h-8',
  md: 'h-10 md:h-12',
  lg: 'h-14 md:h-20',
  xl: 'h-20 md:h-28',
};

// CSS-lockup fallback.
const CSS_SIZES = {
  xs: { circle: 'w-6 h-6 text-[13px]', text: 'text-lg', gap: 'gap-1.5' },
  sm: { circle: 'w-8 h-8 text-[16px]', text: 'text-2xl', gap: 'gap-2' },
  md: { circle: 'w-12 h-12 text-[22px]', text: 'text-4xl', gap: 'gap-3' },
  lg: { circle: 'w-16 h-16 md:w-20 md:h-20 text-[30px] md:text-[38px]', text: 'text-5xl md:text-7xl', gap: 'gap-4 md:gap-5' },
  xl: { circle: 'w-20 h-20 md:w-28 md:h-28 text-[38px] md:text-[54px]', text: 'text-6xl md:text-9xl', gap: 'gap-5 md:gap-7' },
};

/**
 * RalliLogo — renders the official Ralli FORM lockup. The source PNG is
 * already a transparent-background asset (pre-processed from the brand
 * WebP) so no runtime canvas work is required.
 */
export default function RalliLogo({ size = 'md', className = '', withGlow = false }) {
  const { brand, logoUrl } = RALLI;

  if (logoUrl) {
    const sz = IMG_SIZES[size] || IMG_SIZES.md;
    return (
      <img
        src={logoUrl}
        alt="Ralli"
        draggable={false}
        loading="eager"
        decoding="async"
        className={`${sz} w-auto object-contain select-none ${className}`}
        style={withGlow ? { filter: `drop-shadow(0 0 40px ${brand.primary}55)` } : undefined}
        data-testid="ralli-logo"
      />
    );
  }

  // CSS-lockup fallback (used only if logoUrl is unset)
  const s = CSS_SIZES[size] || CSS_SIZES.md;
  return (
    <span
      className={`inline-flex items-center ${s.gap} ${className}`}
      data-testid="ralli-logo"
      aria-label="Ralli"
    >
      <span
        className={`${s.circle} rounded-full flex items-center justify-center font-display leading-none shrink-0`}
        style={{ background: brand.primary, color: brand.ink }}
      >
        R
      </span>
      <span
        className={`${s.text} font-display leading-none tracking-tight`}
        style={{
          color: brand.primary,
          textShadow: withGlow ? `0 0 60px ${brand.primary}55` : 'none',
        }}
      >
        Ralli.
      </span>
    </span>
  );
}
